/* eslint-disable @typescript-eslint/naming-convention */
export const SET_PRODUCT = "@PRODUCTS/SET_PRODUCT";
export type SET_PRODUCT = typeof SET_PRODUCT;

export const SET_PRICE_LIST_ID = "@PRODUCTS/SET_PRICE_LIST_ID";
export type SET_PRICE_LIST_ID = typeof SET_PRICE_LIST_ID;

export const SET_EFFECTIVE_DATE = "@PRODUCTS/SET_EFFECTIVE_DATE";
export type SET_EFFECTIVE_DATE = typeof SET_EFFECTIVE_DATE;

export const PURGE_PRODUCTS = "@PRODUCTS/PURGE_PRODUCTS";
export type PURGE_PRODUCTS = typeof PURGE_PRODUCTS;
